import { createStyles, makeStyles } from '@material-ui/core';

const styles = () =>
  createStyles({
    badge: {
      alignItems: 'flex-start',
      border: '1px solid',
      borderRadius: 14,
      display: 'inline-flex',
      fontSize: 11,
      fontWeight: 700,
      lineHeight: '16px',
      maxWidth: '100%',
      minHeight: 26,
      overflowWrap: 'anywhere',
      padding: '4px 8px',
      whiteSpace: 'normal',
    },
    icon: {
      flexShrink: 0,
      fontSize: 15,
      marginRight: 5,
    },
    iconOnlyBadge: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: 4,
      width: 26,
    },
    iconOnly: {
      marginRight: 0,
    },
  });

export default makeStyles(styles);
